module.exports = __webpack_public_path__ + "static/img/certificate_img18.66a48c39.jpg";